import Client from './Client';

export const AuthApi = {
    signIn: async (formData) => {
        return await Client.post('/v1/auth/signin', formData);
    },
    me: async () => {
        return await Client.post('/v1/auth/me', {});
    },
    refreshToken: async () => {
        // skipAuthRefresh: the refresh request itself must never trigger another
        // token-refresh check, otherwise it would await its own mutex and deadlock.
        return await Client.post('/v1/auth/refresh', {}, true);
    },
    signUp: async (formData) => {
        return await Client.post('/v1/auth/signup', formData);
    },
    recover: async (formData) => {
        return await Client.post('/v1/auth/recover', formData);
    },
    redefine: async (token, formData) => {
        return await Client.post(`/v1/auth/redefine/${token}`, formData);
    }
};

export default AuthApi;
